import React from "react";
import { Col, Row } from "reactstrap";
import Card from "./Card/Card";

const Overview = () => {
  const cardsData = [
    { label: "Total Spend", value: "$3000" },
    { label: "Total Sales", value: "$12000" },
    { label: "Clicks", value: "5000" },
    { label: "Impressions", value: "100000" },
    { label: "Conversion Rate", value: "10%" },
    { label: "Orders", value: "500" },
    { label: "ROAS", value: "4.0" },
    { label: "CTR", value: "5%" },
    { label: "ACoS", value: "25%" },
  ];

  return (
    <section>
      <div className="fw-semibold fs-4 mb-3">Overview</div>
      <div className="p-3 bg-white">
        <Row className="g-0 row-gap-3">
          {cardsData.map((item, index) => (
            <Col key={index} className="pe-3" xs="12" sm="6" xl="4" xxl="2">
              <Card label={item.label} value={item.value} />
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default Overview;